/* ─────────────────────────────────────────────────────────────────────────────
   Sockologie — instant navigation prefetch.

   Mirrors the "hover to pre-fetch the next page" trick fast catalog sites use
   (e.g. McMaster-Carr): when a shopper shows intent to visit an internal page
   (hovers / touches a link) the browser quietly downloads that page's HTML, so
   the actual click feels instant. A small, idle, capped viewport pass also warms
   up links that scroll into view.

   Safe by design:
     • same-origin content links only (products, collections, pages, blogs, home)
     • never cart / checkout / account / add-to-cart / logout / external links
     • respects Save-Data and slow (2g) connections
     • de-dupes and caps total prefetches so it never floods the CDN
     • opt out per-link with data-no-prefetch
   ──────────────────────────────────────────────────────────────────────────── */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var ORIGIN = location.origin;
  var CURRENT = location.href.split('#')[0];
  var done = new Set();
  var MAX = 50;          // hard cap on total prefetches per page view
  var count = 0;

  var SKIP_PATH = /\/(cart|checkout|account|orders|apps|tools)(\/|$)/i;
  var ALLOW_PATH = /^\/($|(products|collections|pages|blogs)\/)/i;

  function eligible(a) {
    if (!a || a.tagName !== 'A' || !a.href) return false;
    if (a.origin !== ORIGIN) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.dataset.noPrefetch != null) return false;
    var rel = (a.getAttribute('rel') || '').toLowerCase();
    if (rel.indexOf('nofollow') > -1 || rel.indexOf('external') > -1) return false;
    var path = a.pathname || '';
    if (SKIP_PATH.test(path)) return false;
    if (!ALLOW_PATH.test(path)) return false;
    var url = a.href.split('#')[0];
    if (url === CURRENT) return false;
    return true;
  }

  function prefetch(url) {
    if (count >= MAX || done.has(url)) return;
    done.add(url);
    count++;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    document.head.appendChild(link);
  }

  // ── Intent-based: hover (desktop) / touchstart (mobile) ──
  var hoverTimer = null;
  function onIntent(e) {
    var a = e.target.closest && e.target.closest('a');
    if (!eligible(a)) return;
    var url = a.href.split('#')[0];
    // tiny delay on hover filters out cursor fly-overs; touch fires immediately
    if (e.type === 'touchstart') {
      prefetch(url);
    } else {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { prefetch(url); }, 60);
    }
  }
  document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
  document.addEventListener('pointerout', function () { clearTimeout(hoverTimer); }, { capture: true, passive: true });

  // Intent-only (hover / touch). No viewport pre-warming, so synthetic audits
  // like Lighthouse — which never hover — see zero extra requests, while real
  // shoppers still get the instant-click feel.
})();
